import { render, staticRenderFns } from "./AccountFeeRuleForm.vue?vue&type=template&id=b0811c80&"
import script from "./AccountFeeRuleForm.vue?vue&type=script&lang=js&"
export * from "./AccountFeeRuleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports